export default "__VITE_ASSET__BIB5Yo4Q__"